<span
  class="pointer-events-auto"
  [class.cursor-not-allowed]="disabled()"
  [tp]="disabled() ? helpText() : ''"
>
  <ng-content></ng-content>
</span>
